<ng-container [formGroup]="workingPeriodForm">
  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'lastWorkingDay'"
      [touched]="workingPeriodForm.get('lastWorkingDay')!.touched"
      >Last Working Day</label
    >
    <div class="col-sm-7">
      <app-datepicker
        [iconLeft]="true"
        formControlName="lastWorkingDay"
      ></app-datepicker>
    </div>
  </div>

  <ng-container *ngIf="workingPeriod.isNewStatusContractor">
    <div class="form__item row mb-4">
      <div class="form-validation d-flex align-items-center col-sm-5">
        <label
          class="d-flex align-items-center col-sm-7"
          appMarkAsterisk
          [formGroup]="workingPeriodForm"
          [controlName]="'rate'"
          [touched]="workingPeriod.rate.touched"
          >Rate per hour</label
        >
        <input
          type="number"
          class="input__basic salary__input__rate"
          formControlName="rate"
          placeholder=" "
        />
        <app-error-field
          [displayError]="workingPeriod.rate.hasError('max')"
          [errorMessage]="'Max value = 999'"
        ></app-error-field>
        <app-error-field
          [displayError]="workingPeriod.rate.hasError('min')"
          [errorMessage]="
            this.workingPeriod.isNewStatusContractor
              ? 'The value should be greater than 0'
              : 'The value should be positive'
          "
        ></app-error-field>
      </div>
    </div>
  </ng-container>

  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'terminationReason'"
      [touched]="workingPeriodForm.get('terminationReason')!.touched"
      >Reason for termination</label
    >
    <div class="col-sm-7">
      <app-dropdown
        formControlName="terminationReason"
        [items]="terminationReasonOptionsList"
        [border]="'classic'"
      ></app-dropdown>
    </div>
  </div>

  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'corporateAccount'"
      [touched]="workingPeriodForm.get('corporateAccount')!.touched"
      >Corporate account</label
    >
    <div class="col-sm-5">
      <app-dropdown
        formControlName="corporateAccount"
        [items]="corporateAccountOptionsList"
        [border]="'classic'"
      ></app-dropdown>
    </div>

    <div
      *ngIf="this.isAccountBlockDate"
      class="col-sm-3 d-flex align-items-center"
    >
      <label
        class="col-sm-3 d-flex align-items-center"
        appMarkAsterisk
        [formGroup]="workingPeriodForm"
        [controlName]="'accountBlockDate'"
        [touched]="workingPeriodForm.get('accountBlockDate')!.touched"
        >Date</label
      >
      <app-datepicker
        [iconLeft]="true"
        formControlName="accountBlockDate"
      ></app-datepicker>
    </div>
  </div>

  <div class="form__item row mb-3" *ngIf="isNewStatusFormer">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'accountCorrespondence'"
      [touched]="workingPeriodForm.get('accountCorrespondence')!.touched"
      >Account Correspondence</label
    >
    <div class="col-sm-7">
      <app-dropdown
        formControlName="accountCorrespondence"
        [items]="accountCorrespondenceOptionsList"
        [border]="'classic'"
      ></app-dropdown>
    </div>
  </div>
  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'equipment'"
      [touched]="workingPeriodForm.get('equipment')!.touched"
      >Equipment</label
    >
    <div class="col-sm-7">
      <app-dropdown
        formControlName="equipment"
        [items]="equipmentOptionsList"
        [border]="'classic'"
      ></app-dropdown>
    </div>
  </div>
  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'location'"
      [touched]="workingPeriodForm.get('location')!.touched"
      >Employee location</label
    >
    <div class="col-sm-3">
      <input
        type="text"
        class="input__basic"
        formControlName="location"
        placeholder=" "
      />
    </div>
  </div>
  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'comment'"
      [touched]="workingPeriodForm.get('comment')!.touched"
      >Comment</label
    >
    <div class="col-sm-3">
      <textarea
        type="textarea"
        class="input__basic"
        formControlName="comment"
        placeholder=" "
      >
      </textarea>
    </div>
  </div>
</ng-container>
